/**
 * Created by Alex on 07/03/2025. handle the case of pasting content from outside
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TaskEditorSyncService {
    pasteValueChange$ = new Subject<string>();
}